import { render, staticRenderFns } from "./BoxPieBox.vue?vue&type=template&id=e33a4a70&scoped=true&"
import script from "./BoxPieBox.vue?vue&type=script&lang=js&"
export * from "./BoxPieBox.vue?vue&type=script&lang=js&"
import style0 from "./BoxPieBox.vue?vue&type=style&index=0&id=e33a4a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33a4a70",
  null
  
)

export default component.exports